var map = {
	"./featured-1.jpg": "b567",
	"./featured-2.jpg": "c91e",
	"./featured-3.jpg": "f6b5",
	"./featured-4.jpg": "4d2b",
	"./featured-5.jpg": "66d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67d0";